module.exports = __webpack_public_path__ + "images/rankingEvents-not-available-1672e935.svg";